function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { j as r } from "./index.es33.js";
import { useState as $, useRef as A, useEffect as K } from "react";
import { clsx as a } from "./index.es105.js";
import { Typography as g } from "./index.es35.js";
import { palette as h } from "./index.es36.js";
import { Icon as l } from "./index.es7.js";
import { inputSelectors as q } from "./index.es107.js";
import { InputHint as C } from "./index.es108.js";
import { NumericInputType as w } from "./index.es119.js";
import i from "./index.es111.js";
import e from "./index.es120.js";
var G = function G(_ref) {
  var m = _ref.isError,
    s = _ref.onChange,
    S = _ref.onBlur,
    n = _ref.isDisabled,
    o = _ref.value,
    d = _ref.label,
    I = _ref.hint,
    W = _ref.maxLength,
    _ref$placeholder = _ref.placeholder,
    v = _ref$placeholder === void 0 ? "0" : _ref$placeholder,
    _ref$isLarge = _ref.isLarge,
    E = _ref$isLarge === void 0 ? !1 : _ref$isLarge,
    _ref$min = _ref.min,
    c = _ref$min === void 0 ? -1 / 0 : _ref$min,
    _ref$max = _ref.max,
    p = _ref$max === void 0 ? 1 / 0 : _ref$max,
    f = _ref.defaultValue,
    y = _ref.formatValue,
    _ref$step = _ref.step,
    b = _ref$step === void 0 ? 1 : _ref$step,
    _ref$type = _ref.type,
    k = _ref$type === void 0 ? w.number : _ref$type,
    _ref$isDecimalAllowed = _ref.isDecimalAllowed,
    B = _ref$isDecimalAllowed === void 0 ? !1 : _ref$isDecimalAllowed;
  var _$ = $(!1),
    _$2 = _slicedToArray(_$, 2),
    M = _$2[0],
    N = _$2[1],
    R = A(null),
    T = B ? /^-?\d|.,+$/ : /^-?\d+$/,
    x = function x(t) {
      t.code === "Tab" && N(!0);
    };
  K(function () {
    return document.addEventListener("keydown", x), function () {
      document.removeEventListener("keydown", x);
    };
  }, []);
  var F = function F(t) {
      return t && Math.max(c, Math.min(p, Number(t))).toString();
    },
    z = function z(t) {
      var u = F(t.target.value);
      if (!s) return o;
      T.test(u) || !u || u.startsWith("-") ? s(u) : s((o === null || o === void 0 ? void 0 : o.toString()) || "");
    },
    H = function H(t) {
      f && !t.target.value.trim().length && s && s(String(f)), S === null || S === void 0 ? void 0 : S(t);
    },
    L = function L() {
      var t = (Number(o) || 0) + b;
      s === null || s === void 0 || s(String(Math.min(t, p)));
    },
    U = function U() {
      var t = (Number(o) || 0) - b;
      s === null || s === void 0 || s(String(Math.max(t, c)));
    },
    j = n ? h.gray5 : h.gray6;
  return r.jsxs("div", {
    children: [d && r.jsx(g.Body2, {
      as: "div",
      className: a(i.labelContainer, i.label),
      children: d
    }), r.jsxs("label", {
      className: a(e.container, _defineProperty({}, e.containerNotDisabledAndNotError, !n && !m)),
      children: [r.jsxs("div", {
        className: a(e.inputWrapper, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, e.disabledWrapper, n), e.wrapperError, m && !n), e.largeInput, E), e.wrapperFocus, M)),
        onBlur: function onBlur() {
          return N(!1);
        },
        children: [r.jsx("div", {
          className: a(i.wrapper, e.numericWrapper, q.classNames.wrapper, _defineProperty(_defineProperty({}, i.wrapperDisabledStyles, n), i.wrapperWithError, m)),
          children: r.jsx(g.Body2, {
            className: a(i.input, e.input),
            as: "input",
            disabled: n,
            ref: R,
            type: k,
            value: y ? y(o) : o,
            maxLength: W,
            onChange: z,
            placeholder: v,
            min: c === null || c === void 0 ? void 0 : c.toString(),
            max: p === null || p === void 0 ? void 0 : p.toString(),
            onBlur: H
          })
        }), r.jsxs("div", {
          className: e.buttonWrapper,
          children: [r.jsx("button", {
            type: "button",
            className: e.button,
            onClick: L,
            disabled: typeof p == "number" && Number(o) >= p || n,
            children: r.jsx(l, {
              icon: l.icons.system.s.utilities.sortingUp,
              size: 16,
              color: j
            })
          }), r.jsx("button", {
            type: "button",
            className: e.button,
            onClick: U,
            disabled: typeof c == "number" && Number(o) <= c || n,
            children: r.jsx(l, {
              icon: l.icons.system.s.utilities.sortingUp,
              size: 16,
              color: j
            })
          })]
        })]
      }), r.jsx(C, {
        isError: m,
        hint: I
      })]
    })]
  });
};
G.NumericInputType = w;
export { G as NumericInput };